/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-10 13:34:24
 * @FilePath: \ui\src\const.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { RobotFilled, UserOutlined } from '@ant-design/icons'
import React, { useEffect, useMemo, useState } from 'react'
// import FunctionCallingPage from './pages/FunctionCallingPage'
import ImageGenPage from './pages/ImageGenPage'
import McpPage from './pages/McpPage'
import MultiModalPage from './pages/MultiModalPage'
import RagPage from './pages/RagPage'
import UploadPage from './pages/UploadPage'
import { Bubble, Prompts, Welcome } from '@ant-design/x'
import { Space, type GetProp, Tag, Typography, Image } from 'antd'
import ReactMarkdown from 'react-markdown'
import ChatPage from './pages/ChatPage'
import { MenuPage } from './stores/functionMenu.store'
import AnimatedSection from './pages/components/AnimatedSection'
import { getQuestion } from './api/question'
import guideImg from '@/assets/icon/AI／icon／guide.png'
import problem from '@/assets/icon/AI／icon／problem.png'

export const BASE_URL = import.meta.env.VITE_BASE_URL
export const DEFAULT_MODEL = 'dashscope'
export const MAX_IMAGE_SIZE = 2048

export const pageComponents = {
  [MenuPage.Chat]: ChatPage,
  [MenuPage.ImageGen]: ImageGenPage,
  [MenuPage.Rag]: RagPage,
  [MenuPage.Mcp]: McpPage,
  [MenuPage.Upload]: UploadPage,
  [MenuPage.MultiModal]: MultiModalPage,
  // [MenuPage.ToolCalling]: FunctionCallingPage,
} as const
interface ActionButtonConfig {
  key: string
  label: string
  icon: React.ReactNode
  baseColor: string
  bgColor: string
  activeColor: string
  description: string
  tipTitle: string
  onClick?: () => void
}
// 按钮配置列表
export const actionButtonConfig: ActionButtonConfig[] = [
  {
    key: 'onlineSearch',
    label: '在线搜索',
    icon: (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="AI/icon/net">
          <circle
            id="Ellipse 12"
            cx="12.5"
            cy="12"
            r="7.25"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            id="Ellipse 13"
            d="M12.5 4.75C13.1674 4.75 13.9732 5.31074 14.6572 6.67871C15.3188 8.00184 15.75 9.88205 15.75 12C15.75 14.118 15.3188 15.9982 14.6572 17.3213C13.9732 18.6893 13.1674 19.25 12.5 19.25C11.8326 19.25 11.0268 18.6893 10.3428 17.3213C9.68121 15.9982 9.25 14.118 9.25 12C9.25 9.88205 9.68121 8.00184 10.3428 6.67871C11.0268 5.31074 11.8326 4.75 12.5 4.75Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <rect
            id="Rectangle 1301"
            x="5"
            y="11.25"
            width="15"
            height="1.5"
            fill="currentColor"
          />
        </g>
      </svg>
    ),
    baseColor: '#212329',
    bgColor: '#F6F8FA',
    activeColor: '#D6E3FF',
    description: '使用网络搜索获取最新信息',
    tipTitle: '使用网络搜索获取最新信息',
  },
  {
    key: 'deepThink',
    label: '深度思考',
    icon: (
      <svg
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="AI/icon/think">
          <path
            id="Ellipse 16"
            d="M17.9802 17.48C18.3879 17.0724 18.5835 16.6253 18.6279 16.1335C18.6739 15.6248 18.5608 15.0243 18.2689 14.3326C17.6797 12.9369 16.4352 11.3389 14.7982 9.70187C13.1613 8.06489 11.5633 6.82045 10.1675 6.23125C9.47581 5.93932 8.87529 5.82622 8.36661 5.87217C7.87484 5.91663 7.42772 6.11224 7.02007 6.51989C6.61242 6.92755 6.41681 7.37466 6.37235 7.86644C6.3264 8.37511 6.4395 8.97564 6.73143 9.66735C7.32063 11.0631 8.56507 12.6611 10.2021 14.2981C11.839 15.935 13.437 17.1795 14.8328 17.7687C15.5245 18.0606 16.125 18.1737 16.6337 18.1278C17.1255 18.0833 17.5726 17.8877 17.9802 17.48Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path
            id="Ellipse 17"
            d="M7.02008 17.4801C6.61243 17.0725 6.41681 16.6253 6.37236 16.1336C6.32641 15.6249 6.43951 15.0244 6.73144 14.3327C7.32064 12.9369 8.56508 11.3389 10.2021 9.70194C11.839 8.06495 13.437 6.82051 14.8328 6.23131C15.5245 5.93938 16.125 5.82629 16.6337 5.87223C17.1255 5.91669 17.5726 6.1123 17.9802 6.51996C18.3879 6.92761 18.5835 7.37472 18.628 7.8665C18.6739 8.37517 18.5608 8.9757 18.2689 9.66741C17.6797 11.0632 16.4352 12.6611 14.7983 14.2981C13.1613 15.9351 11.5633 17.1796 10.1675 17.7688C9.47582 18.0607 8.8753 18.1738 8.36662 18.1278C7.87485 18.0834 7.42773 17.8878 7.02008 17.4801Z"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <circle id="Ellipse 15" cx="12.5" cy="12" r="1" fill="currentColor" />
        </g>
      </svg>
    ),
    baseColor: '#212329',
    bgColor: '#F6F8FA',
    activeColor: '#D6E3FF',
    description: '深度分析问题并给出详细回答',
    tipTitle: '深度分析问题并给出详细回答',
  },
]

const renderTitle = (icon: React.ReactElement, title: string) => (
  <Space align="start">
    {icon}
    <span>{title}</span>
  </Space>
)

export const placeholderPromptsItems: GetProp<typeof Prompts, 'items'> = [
  {
    key: '1',
    label: renderTitle(
      <img src={guideImg} alt="用户指南" style={{ width: '28px' }} />,
      '用户指南'
    ),
    description: '',
    children: [],
  },
  {
    key: '2',
    label: renderTitle(
      <img src={problem} alt="用户指南" style={{ width: '28px' }} />,
      '常见问题'
    ),
    description: '',
    children: [],
  },
]

export const defaultKey = Date.now().toString()
export const defaultConversationsItems = [
  {
    key: defaultKey,
    label: (
      <span>
        对话 1
        <Tag style={{ marginLeft: 8 }} color="green">
          {DEFAULT_MODEL}
        </Tag>
      </span>
    ),
  },
]

export const aiConfig = {
  placement: 'start' as 'start' | 'end',
  avatar: {
    icon: <RobotFilled />,
  },
  styles: {
    content: {
      borderRadius: 16,
    },
  },
  messageRender: (content) => (
    <Typography>
      <ReactMarkdown>{content}</ReactMarkdown>
    </Typography>
  ),
}

export const roles: GetProp<typeof Bubble.List, 'roles'> = {
  ai: {
    typing: { step: 5, interval: 20 },
    ...aiConfig,
  },
  aiHistory: {
    ...aiConfig,
  },
  local: {
    placement: 'end',
    variant: 'shadow',
    avatar: {
      icon: <UserOutlined />,
    },
  },
  file: {
    placement: 'end',
    variant: 'borderless',
    messageRender: (base64: string) => {
      return <Image src={base64} style={{ maxHeight: 250, paddingRight: 32 }} />
    },
    avatar: <></>,
  },
}

export const conversationsMap: Record<
  string,
  {
    model: string
    messages: any[]
    params: { onlineSearch: boolean; deepThink: boolean }
  }
> = {}

// 默认会话界面
export const PlaceholderNode = ({ className, onPromptsItemClick }) => {
  const [rawData, setRawData] = useState(null) // 存储接口原始数据
  const [isNarrow, setIsNarrow] = useState(window.innerWidth < 1000)

  // 1. 监听窗口尺寸变化
  useEffect(() => {
    const handleResize = () => {
      setIsNarrow(window.innerWidth < 1000)
    }
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  // 2. 获取接口数据
  useEffect(() => {
    getQuestion().then((res) => {
      setRawData(res.data)
    })
  }, [])

  // 3. 根据屏幕宽度计算最终显示的 items
  const items = useMemo(() => {
    if (!rawData) return placeholderPromptsItems

    // 格式化数据函数
    const formatChildren = (dataList) =>
      dataList.map((item) => ({
        key: item.hotPromptId,
        description: item.hotPrompt,
        category: item.category,
        extConfig: item.extConfig,
      }))

    // 如果宽度小于 1000px，只保留第一组，并且可能截断子项数量（例如只留 3 个）
    if (isNarrow) {
      return [
        {
          ...placeholderPromptsItems[0],
          children: formatChildren(rawData['1']).slice(0, 3), // 变为一列时，只取前3个
        },
      ]
    }

    // 正常两列模式
    return [
      {
        ...placeholderPromptsItems[0],
        children: formatChildren(rawData['1']),
      },
      {
        ...placeholderPromptsItems[1],
        children: formatChildren(rawData['2']),
      },
    ]
  }, [rawData, isNarrow])

  return (
    <AnimatedSection>
      <Space
        direction="vertical"
        size={16}
        className={className}
        align="center"
      >
        <Welcome
          variant="borderless"
          title="您好，我是森兰Hi.AI"
          styles={{
            title: {
              fontSize: 28,
              fontWeight: 'bold',

              fontFamily: 'SourceHanSans',
            },
            description: {
              fontSize: 16,

              fontFamily: 'SourceHanSans',
            },
          }}
          description="一个以森兰变频器为核心的 AI 助手"
        />
        <Prompts
          items={items}
          styles={{
            list: {
              display: 'flex',
              flexDirection: isNarrow ? 'column' : 'row',
              // 动态调整宽度，窄屏时设为自适应或 100%
              width: isNarrow ? '100%' : '768px',
              maxWidth: '100vw',
            },
            item: {
              flex: 1,
              background: '#F6F8FA',
            },
          }}
          onItemClick={onPromptsItemClick}
        />
      </Space>
    </AnimatedSection>
  )
}
export const RAGPlaceholderNode = () => {
  return (
    <AnimatedSection>
      <Space
        direction="vertical"
        size={16}
        align="center"
        style={{ marginTop: 64 }}
      >
        <Welcome
          variant="borderless"
          title="变频器助手"
          styles={{
            title: {
              fontSize: 28,
              fontWeight: 'bold',
              fontFamily: 'SourceHanSans',
            },
            description: {
              fontSize: 16,
              fontFamily: 'SourceHanSans',
            },
          }}
          description="森兰变频器智能客服"
        />
      </Space>
    </AnimatedSection>
  )
}
